'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

interface ConsultationCTAProps {
  className?: string;
}

const ConsultationCTA = ({ className = '' }: ConsultationCTAProps) => {
  const [isHydrated, setIsHydrated] = useState(false);

  useState(() => {
    setIsHydrated(true);
  });

  const handleWhatsAppClick = () => {
    if (!isHydrated) return;
    const message = encodeURIComponent(
      'Hello! I would like to schedule a consultation about GenCarbon ESG services.'
    );
    window.open(`https://wa.me/919876543210?text=${message}`, '_blank');
  };

  const handleEmailClick = () => {
    if (!isHydrated) return;
    window.location.href = 'mailto:dr.nupur@gencarbon.in?subject=Service Consultation Request';
  };

  return (
    <section className={`bg-gradient-to-br from-primary via-secondary to-primary py-16 md:py-20 ${className}`}>
      <div className="max-w-5xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center">
          <div className="inline-flex items-center space-x-2 bg-primary-foreground/10 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
            <Icon name="CalendarDaysIcon" size={20} className="text-accent" />
            <span className="text-primary-foreground font-medium text-sm">
              Free Initial Consultation
            </span>
          </div>

          <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-primary-foreground mb-6">
            Ready to Start Your Sustainability Journey?
          </h2>

          <p className="text-lg md:text-xl text-primary-foreground/90 mb-10 max-w-3xl mx-auto leading-relaxed">
            Schedule a consultation with Dr. Nupur and our expert team to discuss how we can help achieve your ESG goals and carbon credit objectives.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
            <button
              onClick={handleWhatsAppClick}
              className="w-full sm:w-auto bg-conversion text-conversion-foreground font-heading font-semibold px-8 py-4 rounded-lg hover:bg-conversion/90 shadow-natural hover:shadow-natural-lg transition-all duration-300 flex items-center justify-center space-x-3"
            >
              <Icon name="ChatBubbleLeftRightIcon" size={24} variant="solid" />
              <span>WhatsApp Consultation</span>
            </button>

            <button
              onClick={handleEmailClick}
              className="w-full sm:w-auto bg-primary-foreground text-primary font-heading font-semibold px-8 py-4 rounded-lg hover:bg-primary-foreground/90 shadow-natural hover:shadow-natural-lg transition-all duration-300 flex items-center justify-center space-x-3"
            >
              <Icon name="EnvelopeIcon" size={24} variant="solid" />
              <span>Email Dr. Nupur</span>
            </button>
          </div>

          {/* Contact Info */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-primary-foreground/80">
            <div className="flex items-center space-x-2">
              <Icon name="PhoneIcon" size={18} />
              <span className="text-sm">+91 98765 43210</span>
            </div>
            <div className="hidden sm:block w-1 h-1 bg-primary-foreground/40 rounded-full"></div>
            <div className="flex items-center space-x-2">
              <Icon name="EnvelopeIcon" size={18} />
              <span className="text-sm">dr.nupur@gencarbon.in</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConsultationCTA;